import { render, staticRenderFns } from "./PostsUserList.vue?vue&type=template&id=71628fd3&scoped=true"
import script from "./PostsUserList.vue?vue&type=script&lang=js"
export * from "./PostsUserList.vue?vue&type=script&lang=js"
import style0 from "./PostsUserList.vue?vue&type=style&index=0&id=71628fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71628fd3",
  null
  
)

export default component.exports